export const BASE_DASHBOARD_URL = "/";
export const BASE_LOGIN_URL = "/login";
